import { FormDestinationPicker } from './FormDestinationPicker';

export default FormDestinationPicker;
